import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { MdHourglassBottom, MdOutlineVerified } from 'react-icons/md';
import { MdBarChart, MdPlayCircle } from 'react-icons/md';
import {GoArrowRight} from 'react-icons/go';
import TestsVector from 'assets/vectors/Tests.svg';
import Helmet from 'components/Helmet';
import ButtonLink from 'components/ButtonLink';
import { Test } from 'global/types';
import './index.css';

type MyTestsProps = {
    tests: Test[];
    testType?: string;
};

function MyTests({ tests, testType = 'Digital SAT' }: MyTestsProps) {
    const navigate = useNavigate();
    
    // Determine routes based on test type
    const getTestRoute = (testId: string) => {
        if (testType === 'Digital ACT') {
            return `/digital-act/${testId}`;
        }
        return `/digital/${testId}`;
    };

    const getReportRoute = (testId: string) => {
        if (testType === 'Digital ACT') {
            return `/report/digital-act/${testId}`;
        }
        return `/report/digital-sat/${testId}`;
    };

    const getPersonalizedPlanRoute = () => {
        if (testType === 'Digital ACT') {
            return `/tests/personalizedPlan?kind=act`;
        }
        return `/tests/personalizedPlan?kind=sat`;
    };

    return (
        <>
            {tests.find(test => !test.score && test.inProgress) && <>
                <h4 className='myTests__subHeader'>In progress</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && test.inProgress).map((test, t) => (
                        <button className='myTests__test' onClick={() => navigate(getTestRoute(test.testId))} key={test.testId}>
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>{100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete
                                    </p>
                                    <p>resume {test.testSections.find(testSection => (
                                            testSection.score === null
                                        )).testModules.find(testModule => (
                                            testModule.rawScore === null
                                        )).name}
                                    </p>
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => !test.score && !test.inProgress) && <>
                <h4 className='myTests__subHeader'>Not started</h4>
                <div className='myTests__tests'>
                    {tests.filter(test => !test.score && !test.inProgress).map((test, t) => (
                        <button className='myTests__test' onClick={() => navigate(getTestRoute(test.testId))} key={test.testId}>
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {/* {test.testSections.length === 1
                                        ?   test.testSections[0].subject + ' Only'
                                        :   100*test.testSections.reduce((total, section) => (
                                                total + section.testModules.filter(module => (
                                                    module.rawScore !== null
                                                )).length
                                            ), 0)/test.testSections.reduce((total, section) => (
                                                total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                            ), 0) + '% complete'
                                        } */}
                                        {/* {test.testSections.map((testSection, t) => (
                                            t > 0 ? ` & ${testSection.subject}` : testSection.subject
                                        ))} {test.testSections.length > 1 ? 'Sections' : 'Only'} */}
                                        {100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete
                                    </p>
                                    <p>
                                        {test.testSections.length === 1 && `${test.testSections[0].subject} Only`}
                                    </p>
                                </div>
                            </div>
                            <MdPlayCircle className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {tests.find(test => test.score) && <>
                <div className='myTests__subHeaderDiv'>
                    <h4 className='myTests__subHeader'>Completed</h4>
                    <div className='myTests__subHeaderDivWrapping' onClick={() => navigate(getPersonalizedPlanRoute())}>
                        <h4 className={`myTests__subHeader myTests__button`}>View Personalized Plan</h4>
                        <GoArrowRight className='myTests__subHeaderIcon'/>
                    </div>
                </div>
                <div className='myTests__tests'>
                    {tests.filter(test => test.score).map((test, t) => (
                        <button className='myTests__test' onClick={() => navigate(getReportRoute(test.testId))} key={test.testId}>
                            <img
                                className='myTests__testVector'
                                src={TestsVector}
                            />
                            <div className='myTests__testInfo'>
                                <h2 className='myTests__testName'>{test.name}</h2>
                                <div className='myTests__progressBar'>
                                    <span style={{ width: 
                                        `${100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}%`
                                    }}></span>
                                </div>
                                <div className='myTests__progress'>
                                    <p>
                                        {/* {test.testSections.length === 1
                                        ?   test.testSections[0].subject + ' Only'
                                        :   100*test.testSections.reduce((total, section) => (
                                                total + section.testModules.filter(module => (
                                                    module.rawScore !== null
                                                )).length
                                            ), 0)/test.testSections.reduce((total, section) => (
                                                total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                            ), 0) + '% complete'
                                        } */}
                                        {test.testSections.length > 1 
                                            ? 'Full Test' 
                                            : `${test.testSections[0].subject} Only`
                                        }
                                        {/* {100*test.testSections.reduce((total, section) => (
                                            total + section.testModules.filter(module => (
                                                module.rawScore !== null
                                            )).length
                                        ), 0)/test.testSections.reduce((total, section) => (
                                            total + [...new Set(section.testModules.map(module => module.moduleNumber))].length
                                        ), 0)}% complete */}
                                    </p>
                                    <p>
                                        {new Date(test.testDate).toLocaleString('en-us', { year: 'numeric', month: 'numeric', day: 'numeric' })}
                                    </p>
                                </div>
                            </div>
                            <MdBarChart className='myTests__statusIcon' />
                        </button>
                    ))}
                </div>
            </>}
            {/* <div className='myTests'>
                {tests.map(test => (
                    <div className='myTests__test'>
                        <img
                            className='myTests__vector'
                            src={TestsVector}
                        />
                        <h2 className='myTests__name'>
                            {test.name}
                            {test.score
                                ? <MdOutlineVerified className='myTests__check' />
                                : test.inProgress
                                ? <MdHourglassBottom className='myTests__inProgress' />
                                : <></>
                            }
                        </h2>
                        {test.score
                        ?   <ButtonLink
                                className='myTests__button'
                                to={`/report/digital-sat/${test.testId}`}
                            >
                                VIEW RESULTS
                            </ButtonLink>
                        :   test.inProgress
                        ?   <ButtonLink
                                className='myTests__button'
                                to={`/digital/${test.testId}`}
                            >
                                RESUME
                            </ButtonLink>
                        :   <ButtonLink
                                className='myTests__button'
                                to={`/digital/${test.testId}`}
                            >
                                START
                            </ButtonLink>
                        }
                    </div>
                ))}
            </div> */}
        </>
    );
}

export default MyTests;